export default "__VITE_ASSET__Cs3_sBNW__"